<template>
  <div>
    <div class="i-layout-page-header">
      <PageHeader :title="$route.meta.title" :content="$route.meta.description" hidden-breadcrumb />
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <view-table ref="table" view-code="OrganizationType" @create="$refs.form.open()" @edit="({ row, index }) => $refs.form.open(row)"></view-table>
    </Card>
    <modal-form ref="form" view-code="OrganizationTypeEdit" @on-after-save="$refs.table.loadData()" />
  </div>
</template>
<script>
  import mixinPage from '../../mixins/page';

  export default {
    name: 'system-organizationType',
    mixins: [mixinPage],
    components: {},
    data() {
      return {};
    },
    computed: {},
    created() {},
    methods: {}
  };
</script>
